// tw.js
module.exports = {
  我要: '我要',
  办赛: '辦賽',
  首页: '首頁',
  赛事专区: '賽事專區',
  产品中心: '產品中心',
  机构: '機構',
  教练: '教練',
  运动员: '運動員',
  赛事: '賽事',
  参赛人次: '參賽人次',
  赛事一站式服务平台: '賽事一站式服務平臺',
  创建专属赛事官网: '創建專屬賽事官網',
  赛事数据永久保存: '賽事數據永久保存',
  智能报名规避错报: '智慧報名規避錯報',
  一键抽签编排: '一鍵抽籤編排',
  '一键下载秩序册、对战表': '一鍵下載秩序册、對戰表',
  智能检录呼叫号码: '智慧檢錄呼叫號碼',
  智能竞赛设备: '智慧競賽設備',
  成绩实时云同步: '成績實时雲同步',
  一键制作参赛证奖状: '一鍵製作參賽證獎狀',
  '参数数据、技术分析': '參數數據、技術分析',
  竞赛物联网: '競賽物聯網',
  '为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通':
    '為綜合性運動會、各種項目的所有賽制，建立競賽設備物聯網，線上線下數據互聯互通',
  '裁判打分手柄/技术平板': '裁判打分手柄/平板',
  '运动员穿戴设备、竞赛硬件设备': '運動員穿戴頭盔、護具、脚套',
  录像审议视频采集: '錄影審議視頻採集',
  检录处发送检录通知: '檢錄處發送檢錄通知',
  现场终端: '現場終端',
  记时记分比赛投屏: '記時記分比賽投屏',
  比赛进程: '比賽行程',
  '成绩、人气排行榜': '成績、人氣排行榜',
  技术统计数据分析: '技術統計資料分析',
  比赛直播: '比賽直播',
  比赛场次: '比賽場次',
  竞赛项目: '競賽項目',
  近期赛事: '近期賽事',
  名称: '名稱',
  地区: '地區',
  类型: '類型',
  报名流程: '報名流程',
  选择单位: '選擇機構',
  录入领队及教练: '錄入領隊及教練',
  选手报名: '選手報名',
  参赛选手: '參賽選手',
  '报名完成/下载凭证': '報名完成/下載憑證',
  '您还没有单位，请先创建一个参赛单位': '您還沒有機構，請先創建一個參賽機構',
  赛事主页: '賽事主頁',
  参赛数据: '參賽數據',
  场次对战: '場次對戰',
  奖牌榜: '獎牌榜',
  赛事公告: '賽事公告',
  组织机构: '賽事架構',
  报名时间: '報名時間',
  比赛时间: '比賽時間',
  联系方式: '聯繫方式',
  扫码进入小程序: '掃碼進入小程序',
  开赛时间: '開賽時間',
  赛事地址: '賽事地址',
  赛事级别: '賽事級別',
  赛事热度: '賽事熱度',
  赛事附件: '賽事附件',
  服务范围: '服務範圍',
  联系我们: '聯繫我們',
  新媒体: '新媒體',
  客服工作时间: '客服工作時間',
  '非工作时间我们不能及时回复您的信息，请在站内信留': '非工作時間我們不能及時回復您的信息，請在站內信留',
  下问题或留下您的联系方式我们将在第一时间联系到您: '下問題或留下您的聯繫方式我們將在第一時間聯繫到您',
  道吧小程序: '道吧小程序',
  道吧公众号: '道吧公眾號',
  选择带队成员: '選擇帶隊成員',
  参赛人员信息填写: '參賽人員信息填寫',
  正在修改运动员的报名项目: '正在修改運動員的報名項目',
  继续报名新运动员: '繼續報名新運動員',
  选手姓名: '選手姓名',
  主教练: '主教練',
  '* 主教练': '* 主教練',
  领队: '領隊',
  裁判: '裁判',
  副教练: '副教練',
  经理: '經理',
  官员: '官员',
  队医: '隊醫',
  队长: '隊長',
  点击添加: '點擊添加',
  上传证件照: '上傳證件照',
  身份证号: '身份證號',
  护照号: '護照號',
  必填: '必填',
  '检测通过，自动获取身份证信息': '檢測通過，自動獲取身份證信息',
  '点击检测，获取项目': '點擊檢測，獲取項目',
  本平台购买保险无需上传保单: '本平臺購買保險無需上傳保單',
  '点击检测，获取符合自身年龄段的项目': '點擊檢測，獲取符合自身年齡段的項目',
  '请录入运动员信息后，点击检测': '請錄入運動員信息後，點擊檢測',
  没有检测到符合年龄的项目: '沒有檢測到符合年齡的項目',
  '注：提交之前请检查所报项目，以免错报或误报！': '註：提交之前請檢查所報項目，以免錯報或誤報！',
  报名提交: '報名提交',
  带队成员: '帶隊成員',
  '报名须知：团体项目，请检查报名人数是否满足，若符合报名要求，即可进入到最后一步，下载凭证，若无法进入到下一步，请检查报名信息':
    '報名須知：團體項目，請檢查報名人數是否滿足，若符合報名要求，即可進入到最後一步，下載憑證，若無法進入到下一步，請檢查報名信息',
  运动员参赛信息: '運動員參賽信息',
  报名总人数: '報名總人數',
  我已查看并同意: '我已查看併同意',
  保险条款: '保險條款',
  客户告知书: '客戶告知書',
  报名完成下载凭证: '報名完成/下載憑證',
  恭喜报名成功: '恭喜報名成功',
  下载报名列表: '下載報名列錶',
  官方打印版: '官方打印版',
  完整信息版: '完整信息版',
  下载保险凭证: '下載保險憑證',
  '以机构名义报名参赛，重新选择机构': '以機構名義報名參賽，重新選擇機構',
  上一步: '上一步',
  下一步: '下一步',
  检查报名状态: '查看報名狀態',
  '以个人身份报名参赛，进入选手报名': '以個人身份報名參賽，進入選手報名',
  道吧赛事平台能为组委会: '道吧賽事平臺能為組委會',
  让天下没有难办的赛事: '讓天下沒有難辦的賽事',
  节省: '節省',
  人工: '人工',
  提高: '提高',
  的工作效率: '的工作效率',
  规避: '規避',
  错报漏报: '錯報漏報',
  组委会: '組委會',
  '提供全项目&全赛制，一站式办赛服务支撑': '提供全項目&全賽製，一站式辦賽服務支撐',
  '以智能竞赛系统+竞赛设备双引擎，为国家体育总局、教育部、各省市体育协会、学校、俱乐部等办赛机构，':
    '以智能競賽系統+競賽設備雙引擎，為國家體育總局、教育部、各省市體育協會、學校、俱樂部等辦賽機構，',
  '提供从赛事运营、赛事执行、参赛数据统计&分析及赛事直播、后勤保障等线上+线下一站式服务支撑，':
    '提供從賽事運營、賽事執行、參賽數據統計&分析及賽事直播、後勤保障等線上+線下一站式服務支撐，',
  '服务已达34个省级行政区，90000+场次比赛': '服務已達34個省級行政區，90000+場次比賽',
  查看服务流程: '查看服務流程',
  主管部门: '主管部門',
  '主管部门、体育协会': '主管部门、体育协会',
  '可以通过平台查询、管理辖区内历届各机构、参赛队及运动员的':
    '可以通過平臺查詢、管理轄區內歷屆各機構、參賽隊及運動員的',
  '参赛数据，统计排名，并根据需求提供各种统计分析结果，': '參賽數據，統計排名，並根據需求提供各種統計分析結果，',
  '便于主管部门了解当地体育单位的赛事状况，': '便於主管部門了解當地體育單位的賽事狀況，',
  对并未决策提供科学的数据依据: '對並未決策提供科學的數據依據',
  查看详细介绍: '查看詳細介紹',
  '运动队&运动员': '運動隊&運動員',
  '随时掌握比赛进程；比赛信息互联互通': '隨時掌握比賽進程；比賽信息互聯互通',
  '检录提醒，及时提醒运动员在恰当时间去完成检录': '檢錄提醒，及時提醒運動員在恰當時間去完成檢錄',
  比赛过程中自动完成攻防双方技术统计: '比賽過程中自動完成攻防雙方技術統計',
  '提供对战双方攻防数据统计分析，便于进行赛后总结，': '提供對戰雙方攻防數據統計分析，便於進行賽後總結，',
  '针对性调整训练方法，有效提高运动员成绩': '針對性調整訓練方法，有效提高運動員成績',
  '所有比赛战绩、胜率、积分状况，技术指标等海量数据，实时完整的永久保存':
    '所有比賽戰績、勝率、積分狀況，技術指標等海量數據，實時完整的永久保存',
  成功案例: '成功案例',
  下载中心: '下載中心',
  战略合作单位: '戰略合作單位',
  暂未上传数据: '暫未上傳數據',
  序号: '序號',
  信息: '信息',
  操作: '操作',
  案例准备中: '案例準備中',
  下载: '下載',
  修改资料: '修改資料',
  个人报名运动员管理: '個人報名運動員管理',
  我的机构: '我的機構',
  '你还没有自己的机构，点击创建机构': '你還沒有自己的機構，點擊創建機構',
  成为机构用户: '成為機構用戶',
  授权机构: '授權機構',
  添加授权账号: '添加授權賬號',
  简称: '簡稱',
  '注：简称将用于对战的队伍信息展示': '註：簡稱將用於對戰的隊伍信息展示',
  授权管理: '授權管理',
  普通运动员: '普通運動員',
  团队管理: '團隊管理',
  球队管理: '球隊管理',
  用于比分大图展示: '用於比分大圖展示',
  '注：用于比赛打分投屏（例图）': '註：用於比賽打分投屏（例圖）',
  //服务流程
  赛事执行: '賽事執行',
  赛前: '賽前',
  比赛现场: '比賽現場',
  赛后: '賽後',
  创建赛事官网: '創建賽事官網',
  智能报名: '智慧報名',
  生成参赛证: '生成參賽證',
  资格审查系统: '資格審查系統',
  称重系统: '稱重系統',
  一键抽检编排: '一鍵抽檢編排',
  '秩序册、对战表下载': '秩序册、對戰表下載',
  智能检录: '智慧檢錄',
  成绩实时云端同步: '成績實时雲端同步',
  技术统计分析: '科技統計分析',
  '赛事录屏/直播': '賽事錄屏/直播',
  '奖牌榜/人气榜': '獎牌榜/人氣榜',
  智能体能监测设备: '智慧體能監測設備',
  成绩册下载: '成績册下載',
  参赛视频下载: '參賽視頻下載',
  打印获奖证书: '列印獲獎證書',
  多维度参赛数据分析: '多維度參賽資料分析',
  外延服务: '外延服務',
  保险团购: '保險團購',
  '奖杯 奖牌设计制作': '獎盃獎牌設計製作',
  '保赛事整体VI设计 及制作险团购': '保賽事整體VI設計及製作險團購',
  酒店预订: '酒店預訂',
  赛场导航: '賽場導航',
  餐厅预订: '餐廳預訂',
  智能叫车: '智慧叫車',
  酒店自动入驻: '飯店自動入駐',
  自动退房: '自動退房',
  网上签到: '網上簽到',
  沟通需求: '溝通需求',
  发送赛事规程: '發送賽事規程',
  '专人沟通办赛内容、需求': '專人溝通辦賽內容、需求',
  将赛事规程发送给道吧服务专员: '將賽事規程發送給道吧服務專員',
  组建赛事专属服务团队: '組建賽事專屬服務團隊',
  '团队包含：软件工程师、硬件工程师、赛事督导赛事线上服务专员、赛事现场执行、VI设计':
    '團隊包含：軟體工程師、硬體工程師、賽事督導賽事線上服務專員、賽事現場執行、VI設計',
  赛事财务统计: '賽事財務統計',
  活动专区: '活動專區',
  运动员榜: '運動員榜',
  机构榜: '機构榜',
  场馆: '場館',
}



// WEBPACK FOOTER //
// ./src/i18n/langs/tw.js